import ReactMarkdown, { type Components } from 'react-markdown';

interface MarkdownContentProps {
    content?: string;
    className?: string;
    components?: Components;
}

/**
 * Renders Markdown content safely.
 * Usage: <MarkdownContent content="**Bold** and *italic* text" className="prose" />
 */
const MarkdownContent = ({ content, className = '', components = {} }: MarkdownContentProps) => {
    if (!content) {
        return null;
    }

    return (
        <div className={ className }>
            <ReactMarkdown components={ components }>{content}</ReactMarkdown>
        </div>
    );
};

export default MarkdownContent;
